// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox___Wh9xr","size_s":"size_s___P_sj3","size_m":"size_m___qoB5a"};